// import { Box, Card, CardContent, Typography } from '@mui/material';
// import { Doughnut } from 'react-chartjs-2';
// import { Chart as ChartJS, ArcElement, Tooltip, Legend, Plugin } from 'chart.js';

// // --- 1. Register Chart Components ---
// // Register necessary components for Chart.js
// ChartJS.register(ArcElement, Tooltip, Legend);

// // --- 2. Define the Data Structure (Same as before) ---
// interface ActivityItem {
//   label: string;
//   value: number;
//   percentage: number;
//   color: string;
// }

// const activityData: ActivityItem[] = [
//   { label: 'Tests', value: 400, percentage: 11, color: '#4A3AFF' }, // Light Blue
//   { label: 'Packages', value: 400, percentage: 26, color: '#E0C6FD' }, // Dark Purple
//   { label: 'Refund', value: 10, percentage: 39, color: '#C6D2FD' }, // Medium Purple
//   { label: 'Other', value: 8, percentage: 24, color: '#962DFF' }, // Dark Blue
// ];

// const chartData = {
//   labels: activityData.map(item => item.label),
//   datasets: [
//     {
//       data: activityData.map(item => item.percentage),
//       backgroundColor: activityData.map(item => item.color),
//       borderColor: '#ffffff',
//       borderWidth: 5,
//       cutout: '60%', // Adjusted cutout for better text placement
//       borderRadius: 10, // Adds a slight gap between segments
//     },
//   ],
// };

// // --- 3. Custom Chart.js Plugin to Draw Text ---
// // This plugin iterates over each segment and draws text inside it.
// const DoughnutTextPlugin: Plugin<'doughnut'> = {
//   id: 'doughnutTextPlugin',
//   afterDraw(chart, args, options) {
//     const { ctx, chartArea, data } = chart;
//     ctx.save();
    
//     const meta = chart.getDatasetMeta(0); // Get metadata for the first dataset
    
//     // Iterate over each segment (arc)
//     meta.data.forEach((arc, index) => {
//       const { startAngle, endAngle, x, y, outerRadius, innerRadius } = arc.getProps(['startAngle', 'endAngle', 'x', 'y', 'outerRadius', 'innerRadius']);
      
//       // Calculate the midpoint angle and radius to position the text
//       const midAngle = startAngle + (endAngle - startAngle) / 2;
//       const textRadius = (innerRadius + outerRadius) / 2; // Position in the middle of the ring
      
//       // Calculate the text position
//       const textX = x + Math.cos(midAngle) * textRadius;
//       const textY = y + Math.sin(midAngle) * textRadius;
      
//       const percentage = data.datasets[0].data[index];
//       const label = data.labels?.[index];

//       // Only draw if the segment is large enough for the text
//       if (percentage < 5) return; 

//       // --- Draw Percentage (Large Text) ---
//       ctx.fillStyle = 'white'; // Text color
//       ctx.textAlign = 'center';
//       ctx.textBaseline = 'middle';
//       ctx.font = 'normal 14px Lexend'; // Font styling (ensure Lexend is loaded or use a standard font)
      
//       ctx.fillText(`${percentage}%`, textX, textY - 6); // Offset up slightly

//       // --- Draw Label (Small Text, if needed, though the design only shows percentage) ---
//       // If you wanted the name:
//       // ctx.font = 'normal 10px Lexend';
//       // ctx.fillText(label as string, textX, textY + 12);
//     });

//     ctx.restore();
//   }
// };

// // --- 4. Chart Options (Updated to include the plugin) ---
// const chartOptions = {
//   responsive: true,
//   maintainAspectRatio: true,
//   plugins: {
//     legend: { display: false },
//     tooltip: { enabled: true },
//     // Register the custom plugin here
//     doughnutTextPlugin: DoughnutTextPlugin, 
//   },
// };

// // --- 5. Custom Legend Component & Main Component (Similar to before) ---

// const LegendItem: React.FC<ActivityItem> = ({ label, value, color }) => (
//   <Box
//     sx={{
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       py: 0.5,
//     }}
//   >
//     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//       <Box
//         sx={{
//           width: 10,
//           height: 10,
//           borderRadius: '50%',
//           bgcolor: color,
//           mr: 1.5,
//         }}
//       />
//       <Typography variant="body1" sx={{ fontWeight: 600, color: '#555' }}>
//         {label}
//       </Typography>
//     </Box>
//     <Typography variant="body1" sx={{ fontWeight: 600 }}>
//       {value}
//     </Typography>
//   </Box>
// );

// const MonthlyActivityCard: React.FC = () => {
//   return (
//     <>
//       <CardContent>
//         {/* Headings */}
//         <Typography variant="caption" color="textSecondary" gutterBottom>
//           Statistics
//         </Typography>
//         <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
//           Monthly activity
//         </Typography>
        
//         {/* Chart Section */}
//         <Box sx={{ height: 250, display: 'flex', justifyContent: 'center', mb: 4 }}>
//           {/* We pass the custom plugin in the 'plugins' array */}
//           <Doughnut 
//             data={chartData} 
//             options={chartOptions} 
//             plugins={[DoughnutTextPlugin]} // This line registers the plugin with the chart instance
//           />
//         </Box>
        
//         {/* Legend/Data List */}
//         <Box>
//           {activityData.map((item) => (
//             <LegendItem key={item.label} {...item} />
//           ))}
//         </Box>
//       </CardContent>
//     </>
//   );
// };

// export default MonthlyActivityCard;







import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';
import { 
  Chart as ChartJS, 
  ArcElement, 
  Tooltip, 
  Legend, 
  Plugin,
  ChartData,
  ChartOptions
} from 'chart.js';
import http from "../../../commonFunctions/httpClient";
import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";

// Register Chart Components
ChartJS.register(ArcElement, Tooltip, Legend);

interface MonthlyActivityItem {
  label: string;
  count: number;
  percentage: number;
}

interface MonthlyActivityData {
  month: string;
  totalCount: number;
  items: MonthlyActivityItem[];
}

interface ApiResponse {
  status: boolean;
  message: string;
  data: MonthlyActivityData;
}

const DEFAULT_COLORS = [
  '#4A3AFF', // Tests
  '#E0C6FD', // Packages  
  '#C6D2FD', // Refund
  '#962DFF', // Other
];

const MonthlyActivityCard: React.FC = () => {
  const [activityData, setActivityData] = useState<MonthlyActivityItem[]>([]);
  const [month, setMonth] = useState<string>('');
  const [totalCount, setTotalCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [labId, setLabId] = useState<string>('');

  // Get month names (lowercase for API)
  const getCurrentMonthName = (): string => {
    const monthNames = [
      'january', 'february', 'march', 'april', 'may', 'june',
      'july', 'august', 'september', 'october', 'november', 'december'
    ];
    const currentDate = new Date();
    return monthNames[currentDate.getMonth()];
  };

  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    console.log("🔑 LAB ID:", userId);
    setLabId(userId || '');
  }, []);

  useEffect(() => {
    if (!labId) return;

    const currentMonth = getCurrentMonthName();
    console.log("📅 Current Month:", currentMonth);

    const fetchMonthlyActivity = async () => {
      try {
        setLoading(true);
        // ✅ DYNAMIC MONTH + labId
        const response: any = await http.get(
          `lab/LabDashBoard/monthly-activity?labId=${labId}&month=${currentMonth}`
        );
        console.log("📈 API Response:", response);
        
        let apiData: MonthlyActivityItem[] = [];
        // ✅ Fixed: response.data.items (not response.data.data.items)
        if (response?.data?.items && Array.isArray(response.data.items)) {
          apiData = response.data.items;
        }

        const transformedData = apiData.map((item, index) => ({
          label: item.label,
          count: item.count,
          percentage: item.percentage,
        }));

        if (transformedData.length === 0) {
          transformedData.push(
            { label: 'Test', count: 0, percentage: 0 },
            { label: 'Packages', count: 0, percentage: 0 },
            { label: 'Refund', count: 0, percentage: 0 },
            { label: 'Other', count: 0, percentage: 0 },
          );
        }

        console.log("✅ TRANSFORMED DATA:", transformedData);
        setActivityData(transformedData);
        setMonth(response?.data?.month || `${currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1)} 2026`);
        setTotalCount(response?.data?.totalCount || 0);
      } catch (error: any) {
        console.error("💥 API Error:", error);
        setActivityData([
          { label: 'Test', count: 0, percentage: 0 },
          { label: 'Packages', count: 0, percentage: 0 },
          { label: 'Refund', count: 0, percentage: 0 },
          { label: 'Other', count: 0, percentage: 0 },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchMonthlyActivity();
  }, [labId]);

  const chartData: ChartData<'doughnut'> = {
    labels: activityData.map(item => item.label),
    datasets: [{
      data: activityData.map(item => item.percentage),
      backgroundColor: activityData.map((item, index) => DEFAULT_COLORS[index % DEFAULT_COLORS.length]),
      borderColor: '#ffffff',
      borderWidth: 5,
    }],
  };

  const chartOptions: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: true,
    cutout: '60%',
    plugins: {
      legend: { display: false },
      tooltip: { 
        callbacks: {
          label: (context) => `${context.label}: ${context.parsed}% (${activityData[context.dataIndex]?.count || 0})`
        }
      },
    },
  };

  const DoughnutTextPlugin: Plugin<'doughnut'> = {
    id: 'doughnutTextPlugin',
    afterDraw(chart) {
      const { ctx, chartArea, data } = chart;
      if (!chartArea) return;
      
      ctx.save();
      const meta = chart.getDatasetMeta(0);
      
      meta.data.forEach((arc: any, index: number) => {
        const props = arc.getProps(['startAngle', 'endAngle', 'x', 'y', 'outerRadius', 'innerRadius']);
        const { startAngle, endAngle, x, y, outerRadius, innerRadius } = props;
        
        const midAngle = (startAngle as number) + ((endAngle as number) - (startAngle as number)) / 2;
        const textRadius = ((innerRadius as number) + (outerRadius as number)) / 2;
        const textX = (x as number) + Math.cos(midAngle) * textRadius;
        const textY = (y as number) + Math.sin(midAngle) * textRadius;
        
        const percentage = data.datasets[0].data[index] as number;
        
        if (percentage > 0) {
          ctx.fillStyle = 'white';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.font = 'bold 14px sans-serif';
          ctx.fillText(`${percentage}%`, textX, textY);
        }
      });
      
      ctx.restore();
    }
  };

  if (loading) {
    return (
      <CardContent>
        <Typography variant="caption" color="textSecondary" gutterBottom>
          Statistics
        </Typography>
        <Box sx={{ height: 250, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography>Loading monthly activity...</Typography>
        </Box>
      </CardContent>
    );
  }

  return (
    <CardContent>
      <Typography variant="caption" color="textSecondary" gutterBottom>
        Statistics
      </Typography>
      <Typography variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
        Monthly activity ({month})
      </Typography>
      
      <Box sx={{ height: 250, mb: 4 }}>
        <Doughnut 
          data={chartData} 
          options={chartOptions} 
          plugins={[DoughnutTextPlugin]}
        />
      </Box>
      
      <Box>
        {activityData.map((item, index) => (
          <Box
            key={item.label}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 0.5,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  bgcolor: DEFAULT_COLORS[index % DEFAULT_COLORS.length],
                  mr: 1.5,
                }}
              />
              <Typography variant="body2" sx={{ fontWeight: 600, color: '#555' }}>
                {item.label}
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {item.count}
            </Typography>
          </Box>
        ))}
        <Box sx={{ mt: 2, pt: 1, borderTop: '1px solid #eee', textAlign: 'center' }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Total: {totalCount}
          </Typography>
        </Box>
      </Box>
    </CardContent>
  );
};

export default MonthlyActivityCard;
